<!--
 * @Description: 附件上传
-->
<template>
  <div style="width: 100%">
    <!-- <div>
      <el-upload
        class="upload-demo"
        ref="upload"
        :show-file-list="false"
        :http-request="uploadFile"
        :accept="accept" 
        action=""
        :disabled="imgLoad"
        style="width: 600px"
      >
        <el-button
          style="color: #0286df; border: 1px solid #0286df; padding: 10px 17px"
          :loading="imgLoad"
          @click="checkMax($event)"
          v-if="fileList.length <= limit"
          >上传附件</el-button
        >
      </el-upload>
    </div> -->
    <!-- 拖拽上传格式 -->
    <div  class="setting-form">
      <el-upload
        class="upload-demos"
        ref="upload"
        :show-file-list="false"
        :http-request="uploadFile"        
        action=""
        :disabled="imgLoad"
        drag
        multiple
      >
        <i class="el-icon-upload"></i>
        <div v-if="fileList.length <= limit" v-loading="imgLoad" @click="checkMax($event)" class="el-upload__text" style="width:247px">
          <span style="color:#333">将文件拖到此处，或</span>
          <span style="color: #0286DF">点击上传</span>
        </div>
      </el-upload>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import ObsUpload from 'obs-upload'
/***
 * baseURL: 'https://api.qgbtech.cn',
 * 数据格式：json
 */
import http from '@/http'
const BUCKEt_NAME = 'shigongbang'
let baseServer = process.env.VUE_APP_LOGINAPI
// 获取密钥
const getAuthorization = (bucketName) => {
  return new Promise((resolve, reject) => {
    http.post(baseServer + '/mg-oss-service/file/getObsToken', {bucketName: bucketName}).then(res => {
      let {data: resData, code, msg} = res.data
      if (code === '200') {
        resolve({
          // 可以是临时ak,也可是是固定ak
          ak: resData.ak,
          // 可以是临时sk,也可以是固定sk
          sk: resData.sk,
          // 如果是临时秘钥，此参数必传
          securityToken: resData.securityToken,
          // https://developer.huaweicloud.com/endpoint?OBS
          // 如果上边传了，此处不必传。优先使用此值
          server: resData.endPoint,
          // 如果上边传了，此处不必传。优先使用此值
          // bucketName: resData.bucketName,
          // token 存活时间，相对时间，单位秒。非必传。如果securityToken 过期，则会重新调用getAuthorization 获取临时秘钥token 等参数。比如token 存活时间5分钟，则此值为 300(5*60)。如果不传且为临时秘钥，则每次上传都会重新获取securityToken
          expireSeconds: resData.durationSeconds
        })
      } else {
        // 失败时只接受Error 对象
        reject(new Error(msg))
      }
    }).catch(err => {
      // 失败时只接受Error 对象
      reject(err)
    })
  })
}
// 创建默认配置，如果有额外配置，通过otherConfig传入
const createInitOptions = (bucketName, otherConfig = {}) => {
  return ({
    // server: 'obs.cn-north-4.myhuaweicloud.com',
    bucketName: bucketName,
    getAuthorization(options) {
      return getAuthorization(bucketName)
    },
    ...otherConfig
  })
}
export default {
  name: "UploadBtn",
  props: {
    limit: {
      type: Number,
      default: 5,
    },
    accept: {
      type: String,
      default: "doc,docx,pdf,jpg",
    },
    acceptTips: {
      type: String,
      default:
        "上传格式支持doc,docx,pdf,jpg, 文件大小不能超过10MB",
    },
    fileSize: {
      type: Number,
      default: 10,
    },
    uploadft: {
      type: String,
    },
    fileList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
     return {
      bucketName: BUCKEt_NAME,  // 普通上传使用
      server: '',
      obsUpload:null,
      imgLoad: false
    }
  },
  created() {
     /**
     * 如果你的桶地区不在北京，并且你的上传功能，可能有视频，可能有图片。这种就需要new 2个实例。图片 还是传到老的桶，视频上传到专门的视频桶。
     *
     * 如果你的上传功能，只上传音视频或者只上传非音视频，只需要new 一个实例。
     * */
    this.obsUpload = new ObsUpload(createInitOptions(this.bucketName))
  },
  methods: {
     uploadFile(param) {
      this.imgLoad = true
      
      // 服务器文件存放路径 folderPath: `${env}/zhaocai/ */`
      this.obsUpload.upload(param, {folderPath: `/team/610000/`}).then(res => {
          // obs_upload_data 返回实体内容
          let file = param.file
          let lastName = file.name.substring(file.name.lastIndexOf('.')+1, file.name.length)
          let fileObj = res.obs_upload_data
          let accept = this.accept.split(',')
          let isAllow = accept.indexOf(lastName.toLowerCase())
          if (isAllow == -1) {
            this.$message.error(`${this.acceptTips}`)
            this.imgLoad=false
            return false
          }
          const isLimit = file.size / 1024 / 1024 <= this.fileSize
          if (!isLimit) {
            this.$message.error(`上传文件不得大于${this.fileSize}MB!`)
            this.imgLoad=false
            return false
          }
          let item = {
            url: fileObj.fullUrl,
            name:file.name,
            fileId: file.uid,
            ext: lastName,
            suffix: lastName,
            size: file.size,
            fileUrl: fileObj.fullUrl
          }
          // this.fileList.push(item)      
          this.$emit('change',this.uploadft, {
            status: 'success',
            filesObj: {
              name: item.name,
              fileUrl: item.url,
              fileType: item.ext,
              fileSize: item.size/1024, //kb,
            },
          })
          this.imgLoad = false
        }).catch(err => {
          console.log('catch err');
          this.$message.error(`上传失败，请重新上传`);
          this.imgLoad = false
          console.log(err);
        })
    },
    checkMax(event) {
      if (this.fileList.length == 5) {
        this.$message.error(`最多上传5个附件`);
        event.stopPropagation();
        return false;
      }
    },
  },
};
</script>

<style>
.preview {
  height: 148px;
  width: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.upload-demo .el-upload-list--picture-card .el-upload-list__item {
  overflow: inherit;
}
.upload-demo .el-progress {
  top: 160px;
  width: 100%;
}
.el-upload__tip {
  display: none;
}
.customButton {
  color: #0286df;
  font-size: 14px;
  cursor: pointer;
  display: inline-block;
  box-sizing: border-box;
  border: 1px solid #0286df;
  width: 80px;
}
.customFileList {
  color: #0286df;
  font-size: 14px;
  cursor: pointer;
  padding: 0px 25px;
}
</style>

<style lang="scss">
.setting-form {
    .upload-demos {
      .el-upload-dragger {
        width: 247px;
        height: 50px;
        border: 1px dashed #E4E7ED;
        line-height: 50px;
        &:hover{
        border: 1px dashed #0286DF;
        }
        .el-icon-upload {
          font-size: 30px;
          margin: 0 -5px 0 15px;
          float: left;
          color: #0286DF;
          line-height: 50px;
        }
        .el-upload__text {
          height: 50px !important;
          width: 247px;
          line-height: 50px !important;
          border-radius: 0;
        }
    }
    }
}
</style>
